import React, { useState, useEffect } from "react";
import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import { ArrowDownAZ, ArrowUpAZ, Trash2, Pen, History } from "lucide-react";
import { useNavigate } from "react-router-dom";
import QRCodeGenerator from '../../components/QRCodeGenerator.js';
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const TableRow = ({ data, check, onCheckChange }) => {
    const navigate = useNavigate();

    const handleClickRecord = () => {
        document.cookie = `IDComponente=${data["ID"]}; path=/;`;
        navigate('/dashUtente/scan');
    };

    const handleModifica = () => {
        document.cookie = `IDComponente=${data["ID"]}; path=/;`;
        navigate('/dashUtente/componenti/creaComponente');
    };

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare il componente?")) return;

        try {
            isLoading = true;
            const response = await fetch("/eliminaComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: data["ID"]
                })
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore durante l'eliminazione del componente, riprova più tardi");
            console.log(error);
            window.location.reload();
        }
    };

    return (
        <div className="grid grid-cols-9 gap-1 mt-2">
            <div className='flex items-center justify-end gap-4 mr-2'>
                <input id={data[0]} type="checkbox" className='w-5 h-5 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' checked={check} onChange={onCheckChange} />
            </div>
            <div
                className={`col-span-7 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white 
                    rounded-lg grid grid-cols-3 py-4 text-center break-words items-center`}
                onClick={handleClickRecord}
            >
                <div>{data.Codice === "" ? ("-----") : (data.Codice)}</div>
                <div>{data.Descrizione === "" ? ("-----") : (data.Descrizione)}</div>
                {
                    data["StatoAttuale"] === "In Scadenza" ? (
                        <div className="text-orange-500">{data.ProssimaManutenzione}</div>
                    ) : data["StatoAttuale"] === "Scaduto" ? (
                        <div className="text-red-600">{data.ProssimaManutenzione}</div>
                    ) : (
                        <div>{data.ProssimaManutenzione}</div>
                    )
                }
            </div>
            <div className="flex items-center gap-1">
                {
                    data["Obsoleto"] === false ? (
                        <>
                            <button className="text-blue-500" onClick={handleModifica}>
                                <Pen size={24} />
                            </button>

                            <button className="text-red-500" onClick={handleElimina}>
                                <Trash2 size={24} />
                            </button>
                        </>
                    ) : null
                }
            </div>
        </div>
    );
};


const ComponentiUtente = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Nome", dbCode: "Codice", ascending: true, filter: "text" },
        { value: "Descr.", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Manut.", dbCode: "ProssimaManutenzione", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        Codice: "",
        Descrizione: "",
        ProssimaManutenzione: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const navigate = useNavigate();
    const [infoAzienda, setInfoAzienda] = useState({});
    const [archive, setArchive] = useState(false);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data.filter((d) => d.value["Obsoleto"] === archive));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData.filter((d) => d.value["Obsoleto"] === archive));
    }, [filters]);

    const onload = async () => {
        try {
            isLoading = true;

            await loadFooter();

            const r1 = await fetch("/getComponenti", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0]
                })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                alert(rd1.error);
                console.log(rd1.error);
                navigate('/dashUtente');
            } else {
                setData(rd1.map((d) => ({ value: d, checked: false })));

                const r2 = await fetch("/getInfoAzienda", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0]
                    })
                });

                const rd2 = await r2.json();

                if (r2.status === 500) {
                    alert(rd2.error);
                    console.log(rd2.error);
                    navigate('/dashUtente');
                }
                else {
                    isLoading = false;
                    setInfoAzienda(rd2[0]);
                }
            }
        } catch (error) {
            alert("Errore nel caricare la pagina, riprova più tardi");
            console.log(error);
            navigate('/dashUtente');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const handleCheckTotale = () => {
        let checkTotale = document.getElementById("tot").checked;
        let newData = [...data];
        newData.forEach((d) => d.checked = checkTotale);
        setData(newData);
    };

    const handleCheckChange = (id) => {
        let newData = [...data];
        newData.forEach((d, index) => {
            if (d["value"]["ID"] === id) d.checked = !d.checked;
        });
        setData(newData);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => d.value["Obsoleto"] === newArchive);
        setViewData(newData);
    };


    const handleAggiungi = () => {
        navigate('/dashUtente/componenti/creaComponente');
    };

    const handleStampa = async () => {
        const selectedElements = viewData.filter((d) => d.checked).map((d) => d.value["ID"]);
        if (selectedElements.length === 0) {
            alert("Seleziona almeno un componente da stampare");
            return;
        }
        const qrCodes = await generaQrCode(selectedElements);

        //open window to print all qrCodes
        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.write("<html><head><title>QRCode</title></head><body>");
        qrCodes.forEach((d) => {
            printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
        });
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        await new Promise((resolve) => setTimeout(resolve, 500));
        printWindow.print();
    };

    const generaQrCode = async (ids) => {
        let qrCodes = [];
        for (let i = 0; i < ids.length; i++) {
            qrCodes.push(await QRCodeGenerator.generateQRCode(ids[i]));
        }
        return qrCodes;
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="COMPONENTI" />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                <div className="border-2 border-white rounded-md" id="cardAzienda">
                    <div className="flex justify-center border-b-2 border-white text-lg py-1 font-bold">Informazioni Cliente</div>
                    <div className="px-2 py-2">
                        <p className="flex justify-center"><p className="font-bold">Nome:  </p> {infoAzienda["Nome"]}</p>
                        <p className="flex justify-center mt-1"><p className="font-bold">Email:  </p> {infoAzienda["Email"]}</p>
                        <p className="flex justify-center mt-1"><p className="font-bold">Indirizzo:  </p> {infoAzienda["Indirizzo"]}</p>
                        <p className="flex justify-center mt-1"><p className="font-bold">Città:  </p> {infoAzienda["Citta"]}</p>
                        <p className="flex justify-center mt-1"><p className="font-bold">Provincia:  </p> {infoAzienda["Provincia"]}</p>
                        <p className="flex justify-center mt-1"><p className="font-bold">CAP:  </p> {infoAzienda["Cap"]}</p>
                        {
                            infoAzienda["SIM"] === true ? (
                                <>
                                    <p className="flex justify-center mt-1"><p className="font-bold">Password:  </p> {infoAzienda["Password"]}</p>
                                    <p className="flex justify-center mt-1"><p className="font-bold">Scadenza SIM:  </p> {infoAzienda["ScadenzaSIM"]}</p>
                                </>
                            ) : null
                        }
                    </div>
                </div>
                <div id="bottoni" className="grid grid-cols-2 mt-3">
                    <button
                        onClick={handleAggiungi}
                        className="mr-1 rounded-lg py-2 px-4 bg-green-500 text-white font-bold"
                    >
                        AGGIUNGI
                    </button>
                    <button
                        onClick={handleStampa}
                        className="ml-1 rounded-lg py-2 px-4 bg-blue-500 text-white font-bold"
                    >
                        STAMPA
                    </button>
                </div>
                <div id="tabella">
                    <div className="grid grid-cols-9 grid-row-1 gap-1 mt-4">
                        <div className='flex items-center justify-end mr-2'>
                            <input id="tot" type="checkbox" className="w-5 h-5 px-1 border-2 border-gray-300" onChange={handleCheckTotale} />
                        </div>
                        <div className="col-span-7 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white grid grid-cols-3 py-4 rounded-lg font-bold">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 flex items-center justify-center">
                                        <p className="flex items-center justify-self-center">{d.value}</p>
                                        <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                            {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                        </button>
                                    </div>
                                ))
                            }
                        </div>
                        <div>

                        </div>
                    </div>
                    <div className="grid grid-cols-9 grid-row-1 gap-1 mt-2">
                        <div></div>
                        <div className="col-span-7 rounded-lg grid grid-cols-3 py-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 2 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div className="flex items-center gap-1">
                            <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                <History size={24} />
                            </button>
                        </div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} check={d.checked} onCheckChange={() => handleCheckChange(d.value["ID"])} />
                    ))}
                </div>
            </div>
            <FooterUtente />
        </div>
    );
};

export default ComponentiUtente;